import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AlertesService } from 'src/app/shared/alertes.service';
import { FiltreService } from 'src/app/shared/filtre.service';
import { FormulaireService } from '../../formulaire.service';
import { ModeRenduService } from '../../mode-rendu/mode-rendu.service';
import { SaisieService } from '../../saisie.service';

@Component({
  selector: 'bis-aides-apportees',
  templateUrl: './aides-apportees.component.html',
  styleUrls: ['./aides-apportees.component.css']
})
export class AidesApporteesComponent implements OnInit, OnDestroy {
  @Input()
  erreursMap: Map<string, string>;
  private subFormulaire: Subscription;
  private subTab: Subscription[] = [];  

  public infobulleTotaux: string = 'Le bouton "Calcul Totaux" constitue un outil d\'aide à la saisie. \
  Attention à ne pas l\'utiliser si vous saisissez directement un total sans saisir toutes les valeurs détails,\
  sinon le total que vous avez saisi sera écrasé par le recalcul déclenché par le clic sur le bouton de calcul...';
  
  constructor(
    private formulaireService: FormulaireService,
    public alertesService: AlertesService,
    public modeRendu: ModeRenduService,
    public saisieService: SaisieService,
    public filtreService: FiltreService
  ) { }

  ngOnInit(): void {
   // Pour rafraichir les variables possedant des controles croisés inter onglets !!
      // CtrlE5
      this.filtreService.refreshErreur(this.subTab, 'dg', 'xxRecuVict', 'aidesApportees', 'eeAideCivi');
      // CtrlE6
      this.filtreService.refreshErreur(this.subTab, 'dg', 'xxRecuVict', 'aidesApportees', 'eeAideSarvi');
    

      // Mises à jours de la synthèse si une zone bouge sur l'onglet
    this.subFormulaire = this.formulaire.valueChanges.pipe(distinctUntilChanged(),debounceTime(100)).subscribe(valeur => {
      this.saisieService.majsSynthese(this.formulaireService.getRootForm().get('syntheseBav'), this.formulaireService.getRootForm().get('bav').get('detailBavs'));
    });
    this.formulaire.updateValueAndValidity();
  }

  ngOnDestroy(): void {
    if (this.subFormulaire) {
      this.subFormulaire.unsubscribe();
    }
    if (this.subTab.length !== 0) {
      this.subTab.forEach(element => element.unsubscribe());
    }
  }

  public get formulaire(): UntypedFormGroup {
    return this.formulaireService.getRootForm().get('aidesApportees') as UntypedFormGroup;
  }

  public calculTotalTableauE1(): void {
    //Calcul Total eeEntretTot 
    this.saisieService.calculTotal5(this.formulaire, 'eeEntretTot', 'eeEntretPsy', 'eeEntretJur', 'eeEntretSoc', 'eeEntretEcout', 'eeEntretAutr');
  }

  public calculTotalTableauE2(): void {
    //Calcul Total eeDiliTot 
    this.saisieService.calculTotal19(this.formulaire, 'eeDiliTot', 'eeDiliJur', 'eeDiliCivi', 'eeDiliFondGaran', 'eeDiliSarvi', 'eeDiliPenit', 'eeDiliPolgend', 'eeDiliAvoc', 'eeDiliHuis', 'eeDiliOrgaSoc', 'eeDiliColter', 'eeDiliPref', 'eeDiliOrgaLogt', 'eeDiliHebgt', 'eeDiliHosto', 'eeDiliAsso', 'eeDiliAssur', 'eeDiliSad', 'eeDiliFrserv', 'eeDiliAutr');
  }

}